import { useNavigate } from "react-router-dom";
import logo from "../delta.png";
import { Button, Form, Input, Card } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { login } from "../services/authenticationService";
import { showSuccessToast, showErrorToast } from "../ToastHelper";
import { useContext, useState } from "react";
import { AuthTokenContext, userDataContext } from "../context/tokenContext";
function Login() {
  const navigate = useNavigate();
  const [token, setToken] = useContext(AuthTokenContext);
  const [userData, setUserData] = useContext(userDataContext);
  const [loading,setLoading]=useState(false);
  return (
    <Card
      style={{
        marginTop: "10px",
        width: 500,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.4)",
        borderRadius: "1rem",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        paddingTop:"35px"
        // backgroundColor: "rgb(249 250 250)",
      }}
      bordered={false}
    >
      <Form
        name="normal_login"
        initialValues={{ remember: true }}
        onFinish={async (values) => {
          try {
            setLoading(true)
            let request = {
              email: values.email,
              password: values.password,
            };
            let response = await login(request);
            setLoading(false)
            if (response.statusCode === 0 && response.statusMsg === "Success") {
              localStorage.setItem("token", response.token);
              setToken(response.token);
              setUserData({
                userStatus: response.userStatus,
                userEmail: response.email,
              });

              response.userStatus === "ACT"
                ? navigate("/home/userManagement")
                : navigate("/home/changePassword");
            }
          } catch (e) {
            setLoading(false)

            showErrorToast(e.message);
          }
        }}
        autoComplete="off"
      >
        {/* <Form.Item>
          <img src={logo} alt="logo" className="imgCenter" />
        </Form.Item> */}
        <Form.Item
          name="email"
          rules={[{ required: true, message: "Please input your Email!" }]}
          className="loginFormInputs"
        >
          <Input
            size="large"
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder="Email"
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: "Please input your Password!" }]}
          className="loginFormInputs"
        >
          <Input.Password
            size="large"
            prefix={<LockOutlined className="site-form-item-icon" />}
            placeholder="Password"
          />
        </Form.Item>
        <Form.Item className="formBtn">
          <Button
            type="primary"
            htmlType="submit"
            className="loginBtn"
            size={"large"}
            loading={loading}
          >
            Log in
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
}

export default Login;
